export default __webpack_public_path__ + "static/media/splash-background.faf03eb0.png";